import { render } from "./KioskModuleForm.vue?vue&type=template&id=4aad2df4"
import script from "./KioskModuleForm.vue?vue&type=script&lang=js"
export * from "./KioskModuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__